<div class="models-found">
    <div class="models-found__wrap">
        <p class="models-found--small">{{translationsContainer + '.found' | translate}}</p>
        <p class="models-found--big">{{collectedCarsAmountLabel}}</p>
        <p class="models-found--small">{{amount | amountNounTranslation:translationsContainer | async }} {{vehiclesString |
        translate}}</p>
    </div>
</div>